import Vue from 'vue'
import Router from 'vue-router'

//COMUNES

import Home from '@/components/views/home/home';
const Login = () => import('@/components/views/login/login');
const Registro = () => import('@/components/views/login/registro');
const RegistroAlumno = () => import('@/components/views/login/registro-alumnos');
const RecuperarPass = () => import('@/components/views/login/recuperar-pass');
const setearPass = () => import('@/components/views/login/setear-pass');

const ListadoEncuestas = () => import('@/components/views/encuestas/encuestas');
const FichaEncuesta = () => import('@/components/views/encuestas/ficha-encuesta');

const Eventos = () => import('@/components/views/eventos/eventos');
const FichaEvento = () => import('@/components/views/eventos/ficha-evento');

const Documentacion = () => import('@/components/views/documentacion/documentacion');
const guiaOrientacion = () => import('@/components/views/guia-orientacion/guia-orientacion');


import Error404 from '@/components/views/error-404';

const politicaCookies = () => import('@/components/views/politica-de-cookies');
const politicaPrivacidad = () => import('@/components/views/politica-de-privacidad');
const proteccionDatos = () => import('@/components/views/proteccion-datos');
const condicionespracticasuib = () => import('@/components/views/condiciones-practicas-uib');
const ayuda = () => import('@/components/views/ayuda');

const wrapperPropuestaPracticas = () => import('@/components/views/propuesta-practicas/wrapper-propuesta-practica');

//ALUMNO OWN
const CV = () => import('@/components/views/cv/cv');

const Ofertas = () => import('@/components/views/ofertas/ofertas');
const fichaOfertaAlumno = () => import('@/components/views/ofertas/ficha-oferta-alumno');

const MisCandidaturas = () => import('@/components/views/candidaturas/mis-candidaturas');
const MisPracticas = () => import('@/components/views/mis-practicas/mis-practicas');

const OrientacionLaboral = () => import('@/components/views/orientacion/orientacion-laboral');

const accesoSaml = () => import('@/components/views/acceso-saml');
const accesoEncuesta = () => import('@/components/views/acceso-encuesta');

const mantenimiento = () => import('@/components/views/mantenimiento');
const godmode = () => import('@/components/views/god-mode');

const logout = () => import('@/components/views/logout');


/*--ALUMNO OWN--*/


//EMPRESA OWN

const MiEmpresa = () => import('@/components/views/mi-empresa/mi-empresa');
const MiPerfil = () => import('@/components/views/mi-empresa/mi-perfil');
const FormularioDatos = () => import('@/components/views/mi-empresa/formulario-datos');

const editorOferta = () => import('@/components/views/ofertas/empresas/editor-oferta');
const MisOfertas = () => import('@/components/views/ofertas/empresas/mis-ofertas');
const CvView = () => import('@/components/views/ofertas/empresas/cv-view');
const fichaOfertaEmpresa = () => import('@/components/views/ofertas/empresas/ficha-oferta-empresa');
const visualizadorOferta = () => import('@/components/views/ofertas/empresas/visualizador-oferta');
const programapracticasactivos = () => import('@/components/views/ofertas/empresas/programa-practicas-activos');
const fichaProgramaActivo = () => import('@/components/views/ofertas/empresas/ficha-programa-activo');
const solicitudCambioPracticas = () => import('@/components/views/ofertas/empresas/solicitud-cambio-practicas');
const subirConvenioFirmado = () => import('@/components/views/documentacion/subir-convenio');

const solicitudesEducacion = () => import('@/components/views/solicitudes-educacion');
const fichaOfertaEducacion = () => import('@/components/views/ofertas/empresas/ficha-oferta-educacion');
const editorOfertaEducacion = () => import('@/components/views/ofertas/empresas/editor-oferta-educacion');
const formularioIncorporacion = () => import('@/components/views/ofertas/empresas/formulario-incorporacion');
const actualidad = () => import('@/components/views/noticias/actualidad');
const recursos = () => import('@/components/views/noticias/recursos');
const fichaRecursos = () => import('@/components/views/noticias/ficha-recursos');
const fichaActualidad = () => import('@/components/views/noticias/ficha-actualidad');

import generarNuevoConvenio from '@/components/views/documentacion/generar-nuevo-convenio';

/*--EMPRESA OWN--*/

Vue.use(Router);

import { store } from '@/store/store.js';

import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;
let ca = messages.ca.enlaces;



// Función para obtener títulos según el idioma actual
const getTitlesByLanguage = (language) => {
  return (messages[language] && messages[language].encabezado) || messages.es.encabezado;
};

// Función para actualizar el título de la página
const updatePageTitle = (route, language) => {
  if (route.meta && route.meta.title) {
    const titles = getTitlesByLanguage(language);
    const titleKey = route.meta.name || route.name;
    if (titles[titleKey]) {
      document.title = titles[titleKey];
    } else if (route.meta.title) {
      document.title = route.meta.title;
    }
  }
};

let titles = getTitlesByLanguage('es');

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: {
				requiresAuth: false,
				title: titles.login
			}
		},
		{
			path: '/gma2019',
			name: 'godmode',
			component: godmode,
			meta: {
				requiresAuth: false,
				title: 'Gestor modo Dios'
			}
		},
		{
			path: '/mantenimiento',
			name: 'mantenimiento',
			component: mantenimiento,
			meta: {
				requiresAuth: false,
				title: 'Web en mantenimiento'
			}
		},
		{
			path: '/login/:id',
			name: 'especific-login',
			component: Login,
			meta: {
				requiresAuth: false,
				title: titles.login
			}
		},
		{
			path: es.solicitar_cuenta,
			alias: ca.solicitar_cuenta,
			name: 'solicitar-cuenta',
			component: Registro,
			meta: {
				requiresAuth: false,
				name: 'solicitar_cuenta',
				title: titles.solicitar_cuenta
			}
		},
		{
			path: es.registroalumno,
			alias: ca.registroalumno,
			name: 'registro-alumno',
			component: RegistroAlumno,
			meta: {
				requiresAuth: false,
				name: 'registro_alumno',
				title: titles.registro_alumno,
				permissions: 'canRegistroAlumno'
			}
		},
		{
			path: es.restablecer_login,
			alias: ca.restablecer_login,
			name: 'restablecer-login',
			component: RecuperarPass,
			meta: {
				requiresAuth: false,
				name: 'restablecer_login',
				title: titles.restablecer_login
			}
		},
		{
			path: es.restablecer_candidato,
			alias: ca.restablecer_candidato,
			name: 'restablecer-candidato',
			component: RecuperarPass,
			meta: {
				requiresAuth: false,
				name: 'restablecer_candidato',
				title: titles.restablecer_candidato
			}
		},
		{
			path: es.setear_pass,
			alias: ca.setear_pass,
			name: 'setear-pass',
			component: setearPass,
			meta: {
				requiresAuth: false,
				name: 'setear_pass',
				title: titles.setear_pass
			}
		},
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				requiresAuth: true,
				title: 'Home',
				title: titles.home
			}
		},
		{
			path: es.ofertas_empleo,
			alias: ca.ofertas_empleo,
			name: 'ofertas empleo',
			component: Ofertas,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				ofertaType: 'empleo',
				name: 'ofertas_empleo',
				title: titles.ofertas_empleo
			}
		},
		{
			path: `${es.ofertas_empleo}/:id`,
			alias: `${ca.ofertas_empleo}/:id`,
			name: 'ficha_oferta_alumno_empleo',
			component: fichaOfertaAlumno,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				ofertaType: 'empleo',
				name: 'ficha_oferta_alumno_empleo',
				title: titles.ofertas_empleo,
				isOferta: true
			}
		},
		{
			path: es.ofertas_practicas,
			alias: ca.ofertas_practicas,
			name: 'ofertas_practicas',
			component: Ofertas,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				ofertaType: 'practicas',
				name: 'ofertas_practicas',
				title: titles.ofertas_practicas,
				isOferta: true
			}
		},
		{
			path: `${es.ofertas_practicas}/:id`,
			alias: `${ca.ofertas_practicas}/:id`,
			name: 'ficha_oferta_alumno_practicas',
			component: fichaOfertaAlumno,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				ofertaType: 'practicas',
				name: 'ficha_oferta_alumno_practicas',
				title: titles.ofertas_practicas,
				isOferta: true
			}
		},
		{
			path: `${es.mis_candidaturas}/:id`,
			alias: `${ca.mis_candidaturas}/:id`,
			name: 'ficha_oferta_alumno_practicas-candidaturas',
			component: fichaOfertaAlumno,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				ofertaType: 'practicas',
				name: 'candidaturas',
				title: titles.ofertas_practicas,
				isOferta: true
			}
		},
		{
			path: es.documentacion,
			name: 'documentacion',
			component: Documentacion,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'documentacion',
				title: titles.documentacion
			}
		},
		{
			path: es.subirconvenio,
			alias: en.subirconvenio,
			name: 'subirConvenioFirmado',
			component: subirConvenioFirmado,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'subirConvenioFirmado',
				title: titles.subirConvenioFirmado
			}
		},
		{
			path: es.generarnuevoconvenio,
			name: 'generarNuevoConvenio',
			component: generarNuevoConvenio,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'generarNuevoConvenio',
				title: titles.generarNuevoConvenio
			},
		},
		{
			path: es.guiaOrientacion,
			name: 'guiasOrientacion',
			component: guiaOrientacion,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				name: 'guiasOrientacion',
				title: titles.guiasOrientacion
			}
		},
		{
			path: `${es.nueva_oferta}/:type?`,
			alias: `${ca.nueva_oferta}/:type?`,
			name: 'nueva-oferta',
			component: editorOferta,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'nueva_oferta',
				title: titles.nueva_oferta
			}
		},
		{
			path: `${es.editar_oferta}/:idOferta`,
			name: 'editar oferta',
			component: editorOferta,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'editar_oferta',
				title: titles.editar_oferta,
				isOferta: true
			}
		},
		{
			path: `${es.mis_ofertas}`,
			alias: `${ca.mis_ofertas}`,
			name: 'mis ofertas',
			component: MisOfertas,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'mis_ofertas',
				title: titles.mis_ofertas,
			}
		},
		{
			path: `${es.mis_ofertas}/:id`,
			alias: `${ca.mis_ofertas}/:id`,
			name: 'ficha mis ofertas',
			component: MisOfertas,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'mis_ofertas',
				title: titles.mis_ofertas,
				isOferta: true
			}
		},
		{
			path: `${es.mi_oferta}/:id`,
			name: 'ficha_oferta_empresa',
			component: fichaOfertaEmpresa,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'ficha_oferta_empresa',
				title: titles.mi_oferta,
				isOferta: true
			}
		},
		{
			path: `${es.visualizar_oferta}/:id`,
			alias: `${en.visualizar_oferta}/:id`,
			name: 'visor_oferta',
			component: visualizadorOferta,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				ofertaType: 'practicas',
				name: 'visor_oferta',
				title: titles.visor_oferta,
				isOferta: true
			}
		},
		{
			path: es.mi_empresa,
			alias: ca.mi_empresa,
			name: 'mi empresa',
			component: MiEmpresa,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'mi_empresa',
				title: titles.mi_empresa
			}
		},
		{
			path: es.formulario_datos,
			alias: ca.formulario_datos,
			name: 'Formulario Datos',
			component: FormularioDatos,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'formulario_datos',
				title: titles.formulario_datos
			}
		},
		{
			path: es.programapracticasactivos,
			name: 'programapracticasactivos',
			component: programapracticasactivos,
			meta: {
				requiresAuth: true,
				name: 'programapracticasactivos',
				title: titles.programapracticasactivos
			}
		},
		{
			path: `${es.programapracticasactivos}/:id`,
			name: 'ficha-programa-activo',
			component: fichaProgramaActivo,
			meta: {
				requiresAuth: true,
				name: 'fichaProgramaActivo',
				title: titles.programapracticasactivos,
				isOferta: true
			}
		},
		{
			path: es.solicitarcambiopracticas,
			name: 'solicitarcambiopracticas',
			component: solicitudCambioPracticas,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'solicitudCambioPracticas',
				title: titles.solicitudCambioPracticas
			}
		},
		{
			path: es.mi_perfil,
			alias: en.mi_perfil,
			name: 'mi_perfil',
			component: MiPerfil,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'mi_perfil',
				title: titles.mi_perfil
			}
		},
		{
			path: `${es.vercv}/:id`,
			alias: `${ca.vercv}/:id`,
			name: 'cv-view',
			component: CvView,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'cv_view',
				title: titles.cv_view
			}
		},
		{
			path: es.cv,
			name: 'cv',
			component: CV,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				name: 'cv',
				title: titles.cv
			}
		},
		{
			path: es.mis_candidaturas,
			alias: ca.mis_candidaturas,
			name: 'mis-candidaturas',
			component: MisCandidaturas,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				name: 'mis_candidaturas',
				title: titles.mis_candidaturas
			}
		},
		{
			path: es.mis_practicas,
			name: 'mis-practicas',
			component: MisPracticas,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				name: 'mis_practicas',
				title: titles.mis_practicas
			}
		},
		{
			path: `${es.propuesta_practicas}`,
			name: 'alta-espontanea',
			component: wrapperPropuestaPracticas,
			meta: {
				requiresAuth: true,
				name: 'propuesta_practicas',
				title: titles.propuesta_practicas
			}
		},
		{
			path: es.eventos,
			alias: ca.eventos,
			name: 'eventos',
			component: Eventos,
			meta: {
				requiresAuth: true,
				name: 'eventos',
				title: titles.eventos
			}
		},
		{
			path: `${es.eventos}/:id`,
			alias: `${ca.eventos}/:id`,
			name: 'evento-ficha',
			component: FichaEvento,
			meta: {
				requiresAuth: true,
				name: 'eventos',
				title: titles.eventos
			}
		},
		{
			path: `${es.eventospublico}/:id`,
			alias: `${ca.eventospublico}/:id`,
			name: 'evento-ficha-publico',
			component: FichaEvento,
			meta: {
				requiresAuth: false,
				name: 'eventos',
				title: titles.eventos
			}
		},
		{
			path: es.encuestas,
			alias: ca.encuestas,
			name: 'encuestas',
			component: ListadoEncuestas,
			meta: {
				requiresAuth: true,
				title: titles.encuestas
			}
		},
		{
			path: `${es.encuestas}/:id`,
			alias: `${ca.encuestas}/:id`,
			name: 'ficha_encuestas',
			component: FichaEncuesta,
			meta: {
				requiresAuth: false,
				title: titles.encuestas
			}
		},
		{
			path: `${es.encuestas}/:id/acceso`,
			alias: `${ca.encuestas}/:id/acceso`,
			name: 'acceso_encuesta',
			component: FichaEncuesta,
			meta: {
				requiresAuth: false,
				title: titles.encuestas
			}
		},
		{
			path: es.orientacion,
			name: 'orientacion',
			component: OrientacionLaboral,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				title: titles.orientacion
			}
		},
		{
			path: es.practicaseducacion,
			name: 'solicitudes-educacion',
			component: solicitudesEducacion,
			meta : {
				requiresAuth : true,
				requiresEmpresa : true,
				name : 'solicitudesEducacion',
				title : titles.solicitudesEducacion
			}
		},
		{
			path: `${es.practicaseducacion}/:id`,
			name: 'ficha-solicitudes-educacion',
			component: fichaOfertaEducacion,
			meta : {
				requiresAuth : true,
				requiresEmpresa : true,
				name : 'solicitudesEducacion',
				title : titles.solicitudesEducacion
			}
		},
		{
			path: `${es.practicaseducacion}/:id/editar`,
			alias: `${ca.practicaseducacion}/:id/editar`,
			name: 'editor-solicitudes-educacion',
			component: editorOfertaEducacion,
			meta : {
				requiresAuth : true,
				requiresEmpresa : true,
				name : 'solicitudesEducacion',
				title : titles.solicitudesEducacion
			}
		},
		{
			path: es.politica_privacidad,
			name: 'politica-de-privacidad',
			component: politicaPrivacidad,
			meta: {
				requiresAuth: false,
				title: titles.politica_privacidad
			}
		},
		{
			path: es.politica_cookies,
			name: 'politica-de-cookies',
			component: politicaCookies,
			meta: {
				requiresAuth: false,
				title: titles.politica_cookies
			}
		},
		{
			path: `${es.proteccion_datos}/:id`,
			name: 'proteccion_datos',
			component: proteccionDatos,
			meta: {
				requiresAuth: false,
				title: titles.proteccion_datos,
				name: 'proteccion_datos',
			}
		},
		{
			path: es.ayuda,
			alias: ca.ayuda,
			name: 'ayuda',
			component: ayuda,
			meta: {
				requiresAuth: true,
				requiresAlumno: true,
				title: titles.ayuda,
				name : 'ayuda'
			}
		},
		{
			path: es.acceso_saml,
			alias: ca.acceso_saml,
			name: 'acceso-saml',
			component: accesoSaml,
			meta: {
				requiresAuth: false,
				title: 'Acceso'
			}
		},
		{
			path: es.logout,
			alias: ca.logout,
			name: 'logout',
			component: logout,
			meta: {
				requiresAuth: false,
				title: 'Logout'
			}
		},
		{
			path: es.practicaseducacion,
			name: 'solicitudes-educacion',
			component: solicitudesEducacion,
			meta: {
				requiresAuth: true,
				requiresEmpresa: true,
				name: 'solicitudesEducacion',
				title: titles.mi_empresa
			}
		},
		{
			path: es.condicionespracticasuib,
			alias: ca.condicionespracticasuib,
			name: 'condiciones-practicas-uib',
			component: condicionespracticasuib,
			meta: {
				requiresAuth: false,
				name: 'condicionespracticasuib',
				title: titles.mi_empresa
			}
		},
		{
			path: '/formulario-incorporacion',
			name: 'formulario-incorporacion',
			component: formularioIncorporacion,
			meta: {
				requiresAuth: false,
				title: titles.formulario_incorporacion,
				name: 'formulario_incorporacion'
			}
		},
		{
			path: '/actualidad',
			name: 'actualidad',
			component: actualidad,
			meta: {
				requiresAuth: true,
				title: titles.actualidad,
				name: 'actualidad'
			}
		},
		{
			path: '/actualidad/:id',
			name: 'ficha-actualidad',
			component: fichaActualidad,
			meta : {
				requiresAuth : true,
				title: titles.actualidad,
				name : 'actualidad'
			}
		},
		{
			path: '/recursos',
			name: 'recursos',
			component: recursos,
			meta: {
				requiresAuth: true,
				title: titles.recursos,
				name: 'recursos'
			}
		},
		{
			path: '/recursos/:id',
			name: 'ficha-recursos',
			component: fichaRecursos,
			meta : {
				requiresAuth : true,
				title: titles.recursos,
				name : 'recursos'
			}
		},
		
		{ path: '*', redirect: '/' },
		{ path: "/404", component: Error404, name: 'error404' },
	
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

import VueAnalytics from 'vue-analytics';


if (!!store.getters.getBrand.analitycs) {

	if (document.cookie.includes('cookieyes-analytics=yes')) {

		Vue.use(VueAnalytics, {
			id: store.getters.getBrand.analitycs,
			router,
			debug: {
				sendHitTask: store.getters.getInProduction,
			},

		});

	}
}

router.beforeEach((to, from, next) => {

	let allowedMantenimiento = ['/mantenimiento', '/gma2019'];

	if ((!allowedMantenimiento.some(e => e == to.path)) & store.getters.getInMantenimiento & !!!window.localStorage.getItem('godMode')) {

		next({ name: 'mantenimiento' })
		return
	} else {

		//COMPRUEBO INICIO DE SESIÓN Y SI ESTÁ LOGADO


		if (to.matched.some(route => route.meta.requiresAuth != false) && !store.getters.getLogged) {
			window.sessionStorage.setItem('prelogin', location.pathname);
			next({ name: 'login' })
			return
		}

		//COMPRUEBO SI LA VISTA ES SOLO PARA EMPRESA Y SI NO LO ES, LE LLEVO A LA HOME
		if (to.matched.some(route => route.meta.requiresEmpresa) && !store.getters.isEmpresa) {
			next({ name: 'home' })
			return
		}

		//COMPRUEBO SI LA VISTA ES SOLO PARA ALUMNO Y SI NO LO ES, LE LLEVO A LA HOME
		if (to.matched.some(route => route.meta.requiresAlumno) && !store.getters.isAlumno) {
			next({ name: 'home' })
			return
		}

		//COMPRUEBO SI TIENE SESIÓN INICIADA Y LE LLEVO A LA HOME
		if ((to.path.indexOf('/login') != -1) && store.getters.getLogged) {
			next({ name: 'home' })
			return
		}



		//COMPRUEBO SI NECESITA PERMISO
		if (!!to.meta.permissions && !!!store.getters.getBrand[to.meta.permissions]) {
			next({ name: 'home' })
			return
		}


		if (!!to.meta.title) {
			// Obtener el idioma actual del store
			const currentLanguage = store.getters.getLanguage || 'es';
			updatePageTitle(to, currentLanguage);
			//document.head.querySelector("[name=description]").content = meta.description;
		}

	}

	next()

});

router.onError(error => {
	if (/loading chunk \d* failed./i.test(error.message)) {
		router.push({ name: 'error404' });
	}
})



export default router;
export { updatePageTitle };




// WEBPACK FOOTER //
// ./src/router/index.js